import { Select as AntSelect, SelectProps } from 'antd'
import styled from 'styled-components'

import { GrainType, SelectValueType, Selects } from 'types'
import { RICE_LOT } from 'consts'

interface Props {
  onChange: (grainType: SelectValueType<GrainType>) => void
  value?: SelectValueType<GrainType>
  width?: string
}

const { Option } = AntSelect

const Select = styled(AntSelect)<SelectProps & { width?: string }>`
  .ant-select-selector {
    width: ${({ width }) => width && width} !important;
  }
`

const grainTypes = [
  GrainType.SHORT,
  GrainType.CRYSTAL_MEDIUM,
  GrainType.PEARL_MEDIUM,
  GrainType.LONG,
  GrainType.NO_TYPE,
]

export const GrainTypeSelect: React.FC<Props> = ({ onChange, value, width }) => {
  const grainTypesOptions =
    grainTypes.map(grainType => ({
      label: RICE_LOT.GRAIN_TYPE_NAME_MAP[grainType],
      value: grainType,
    })) ?? []

  return (
    <Select
      listHeight={300}
      placeholder="Sin seleccionar..."
      notFoundContent={'No hay coincidencia'}
      value={value ?? Selects.ALL_OPTIONS}
      onChange={onChange}
      width={width}
    >
      <Option value={Selects.ALL_OPTIONS}>Todos los tipos</Option>
      {grainTypesOptions.map(grainType => (
        <Option key={grainType.value} value={grainType.value}>
          {grainType.label}
        </Option>
      ))}
    </Select>
  )
}
